import React from 'react';
import Image from './Image';

import './Footer.scss';

export default () => (
    <div className="app-footer">
        <div className="desc-container">
            <div className="desc-content">
                <div className="desc-divider-container">
                    <div className="desc-divider">
                        <span className="desc-title meituan-desc-title">发起方</span>
                        <div className="middle-line meituan-middle-line" />
                    </div>
                    <div className="desc-divider">
                        <span className="desc-title">战略合作伙伴</span>
                        <div className="middle-line" />
                    </div>
                </div>
                <div className="logo-list">
                    <div className="logo-item">
                        <Image name="meituan" className="meituan" />
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端/中国科协生态环境-产学联合体" className="logo-image" />
                        <span className="logo-title">中国科协生态环境产学联合体
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端/中国石油和化学工-业联合会" className="logo-image" />
                        <span className="logo-title">中国石油和化学工业联合会
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div className="desc-container">
            <div className="desc-content">
                <div className="desc-divider">
                    <span className="desc-title">联合支持单位</span>
                    <div className="middle-line" />
                </div>
                <div className="logo-list">
                    <div className="logo-item">
                        <Image name="青山移动端/中国环境科学学会" className="logo-image" />
                        <span className="logo-title">中国环境科学学会
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端/中国循环经济协会" className="logo-image" />
                        <span className="logo-title">中国循环经济协会
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端/中国包装联合会" className="logo-image" />
                        <span className="logo-title">中国包装联合会
                        </span>
                    </div>
                </div>
                <div className="logo-list">
                    <div className="logo-item">
                        <Image name="青山移动端/中国物资再生协会" className="logo-image" />
                        <span className="logo-title">中国物资再生协会
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端/中国生态学会" className="logo-image" />
                        <span className="logo-title">中国生态学会
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端/中国可再生能源学会" className="logo-image" />
                        <span className="logo-title">中国可再生能源学会
                        </span>
                    </div>
                </div>
                <div className="logo-list">
                    <div className="logo-item">
                        <Image name="青山移动端/中国复合材料学会" className="logo-image" />
                        <span className="logo-title">中国复合材料学会
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端/生态环境部环境发-展中心" className="logo-image" />
                        <span className="logo-title">生态环境部环境发展中心
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="中国塑料加工工业协会" className="logo-image" />
                        <span className="logo-title">中国塑料加工工业协会</span>
                    </div>
                </div>
                <div className="logo-list">
                    <div className="logo-item">
                        <Image name="青山移动端_中国制浆造纸研究院" className="logo-image" />
                        <span className="logo-title">中国制浆造纸研究院</span>
                    </div>
                    <div className="logo-item">

                    </div>
                    <div className="logo-item">
                    </div>
                </div>
            </div>
        </div>
        <div className="desc-container">
            <div className="desc-content">
                <div className="desc-divider">
                    <span className="desc-title">产业合作伙伴</span>
                    <div className="middle-line" />
                </div>
                <div className="logo-list">
                    <div className="logo-item">
                        <Image name="青山移动端_绿色再生塑料供应链联合工作组" className="logo-image" />
                        <span className="logo-title">绿色再生塑料供应链联合工作组
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端_餐饮外卖绿色包装应用工作组" className="logo-image" />
                        <span className="logo-title">餐饮外卖绿色包装应用工作组
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端_德国国际合作机构" className="logo-image" />
                        <span className="logo-title">德国国际合作机构
                        </span>
                    </div>
                </div>
                <div className="logo-list">
                    <div className="logo-item">
                        <Image name="青山移动端_ImpactHubShanghai" className="logo-image" />
                        <span className="logo-title">Impact Hub Shanghai
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端_璞跃中国" className="logo-image" />
                        <span className="logo-title">璞跃中国 Plug and Play China
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端_金融支持绿色科技平台" className="logo-image" />
                        <span className="logo-title">金融支持绿色科技平台
                        </span>
                    </div>
                </div>
                <div className="logo-list">
                    <div className="logo-item">
                        <Image name="青山移动端_中关村创蓝清洁空气产业联盟" className="logo-image" />
                        <span className="logo-title">中关村创蓝清洁空气产业联盟
                        </span>
                    </div>
                    <div className="logo-item">
                        <Image name="青山移动端_绿色创业汇" className="logo-image" />
                        <span className="logo-title">绿色创业汇
                        </span>
                    </div>
                    <div className="logo-item">
                    </div>
                </div>
            </div>
        </div>
        <div className="contact-info">
            <div>
                <Image name="青山移动端/img-美团青山" className="contact-logo" />
            </div>
            <p>联系我们</p>
            <p>huanbao@meituan.com</p>
            <div className="beian-info">
                <p>北京三快在线科技有限公司</p>
                <p>©️meituan.com 京ICP证070791号</p>
                <p>京公安网备 11000002002052号</p>
            </div>
        </div>
    </div>
);
